module.exports = __webpack_public_path__ + "73c6f24cb2ed8a3c2f0cad93b92ee6b5.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/spreadsheet.png
// module id = 2256
// module chunks = 0